import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onSetPassword = (token, newPassword) =>
  axios.patch(`${apiPaths.passwordBase}/reset`, {
    token,
    new_password: newPassword
  });

const onForgotPassword = (email) => axios.post(`${apiPaths.passwordBase}/request-reset`, { email });

const onChangePassword = (currentPassword, newPassword, userId) =>
  axios.patch(
    `${apiPaths.passwordBase}/change`,
    {
      current_password: currentPassword,
      new_password: newPassword
    },
    {
      params: { user_uuid: userId }
    }
  );

export { onForgotPassword, onSetPassword, onChangePassword };
